export default __webpack_public_path__ + "static/media/banner01.e897c295.jpeg";